import { MatIconModule } from '@angular/material/icon';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Type, ViewEncapsulation } from '@angular/core';
import { FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';

interface InputProps extends FormlyFieldProps {}
export interface FormlyInputFieldConfig extends FormlyFieldConfig<InputProps> {
    type: 'radio-read' | Type<RadioReadType>;
}
@Component({
  selector: 'radio-read-type',
  encapsulation  : ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone     : true,
  template: `
      <div class="">
      <div class="max-w-full flex flex-row items-center space-y-1 text-gray-500 list-disc list-inside dark:text-gray-400 ">
      <mat-icon class="icon-size-5 mr-2" [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
        <span class="">{{getValue()}}</span>
      </div>
    </div>
  `,
  imports:[MatIconModule]
})
export class RadioReadType extends FieldType<FieldTypeConfig<InputProps>>{

    getValue(): string {

        const value = this.formControl.value
        const options = this.props.options as Array<any>

        if (options) {
          return options.filter((x: any) => String(x.value) == String(value))[0]?.label
        }
        else {
          return value
        }
      }


      // const values = this.formControl.value
      // const options = this.props.options as Array<any>
      // const results = [];

      // if (options){
      //     for (let key in values){
      //         const vv = options.filter((x: any) => ( values[key] && x.value == key ))
      //         vv.length && results.push(vv[0].label)
      //     }
      // }

      // return results
}
